import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function OurHistoryPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-44 md:pt-52 pb-0 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section 1: Hvem er Vejle Auto Export? */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-24">
          {/* Left Column: Text Content */}
          <div className="lg:col-span-7 space-y-6">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black italic text-[#293e30] tracking-tight leading-tight uppercase mb-6">
              {t('history.title')}
            </h1>
            <p className="text-lg text-slate-700 leading-relaxed font-medium">
              {t('history.desc')}
            </p>
            <p className="text-slate-600 leading-relaxed">
              {t('history.p2')}
            </p>
            <p className="text-slate-600 leading-relaxed">
              {t('history.p3')}
            </p>
            
            {/* Segment List */}
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 pl-0">
              {[
                t('history.segment_b2b'),
                t('history.segment_b2c'),
                t('history.segment_leasing'),
                t('history.segment_auctions'),
                t('history.segment_banks')
              ].map((segment, index) => (
                <li key={index} className="flex items-center gap-3 text-slate-700 font-medium">
                  <Check className="h-5 w-5 text-[#293e30] shrink-0" />
                  <span>{segment}</span>
                </li>
              ))}
            </ul>

            <p className="text-slate-600 leading-relaxed pt-2">
              {t('history.p4')}
            </p>

            {/* LÆS OGSÅ OM */}
            <div className="pt-6 border-t border-slate-100">
              <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">
                {t('history.read_also')}
              </h4>
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => navigate('/', { state: { scrollTo: 'vurdering-form' } })}
                  className="inline-flex items-center gap-2 text-slate-900 hover:text-[#293e30] font-bold text-sm uppercase tracking-wider transition-colors cursor-pointer"
                >
                  <Check className="h-4 w-4 text-[#293e30]" />
                  {t('history.read_sell')}
                </button>
                <button
                  onClick={() => navigate('/export-cars')}
                  className="inline-flex items-center gap-2 text-slate-900 hover:text-[#293e30] font-bold text-sm uppercase tracking-wider transition-colors cursor-pointer"
                >
                  <Check className="h-4 w-4 text-[#293e30]" />
                  {t('history.read_export')}
                </button>
              </div>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="lg:col-span-5">
            <div className="relative">
              <img 
                src="https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/636e989a-1208-40f5-bec5-d8ba5b8e927f.jpg" 
                alt="Vejle Auto Export" 
                className="w-full h-[450px] object-cover rounded-none shadow-2xl"
              />
            </div>
          </div>
        </div>

        {/* Section 2: Hvad får jeg ud af at sælge min bil til Vejle Auto Export? */}
        <div className="bg-slate-50 p-8 md:p-12 rounded-none border border-slate-100 mb-24">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-black italic text-[#293e30] uppercase tracking-tight mb-10 text-center">
            {t('history.sec2_title')}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            {/* Value 1 */}
            <div className="space-y-2">
              <h3 className="font-black italic text-lg text-[#293e30] uppercase tracking-tight">
                {t('history.val1_title')}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t('history.val1_desc')}
              </p>
            </div>

            {/* Value 2 */}
            <div className="space-y-2">
              <h3 className="font-black italic text-lg text-[#293e30] uppercase tracking-tight">
                {t('history.val2_title')}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t('history.val2_desc')}
              </p>
            </div>

            {/* Value 3 */}
            <div className="space-y-2">
              <h3 className="font-black italic text-lg text-[#293e30] uppercase tracking-tight">
                {t('history.val3_title')}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t('history.val3_desc')}
              </p>
            </div>

            {/* Value 4 */}
            <div className="space-y-2">
              <h3 className="font-black italic text-lg text-[#293e30] uppercase tracking-tight">
                {t('history.val4_title')}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t('history.val4_desc')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: - KONTAKT OS - CTA */}
      <div className="w-full bg-slate-950 py-20 mt-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-3xl md:text-4xl font-black italic text-white uppercase tracking-tight mb-6">
              {t('history.sec3_title')}
            </h3>
            <p className="text-[#f1f1f1] mb-8">
              {t('history.sec3_desc')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/kontakt')}
                className="px-8 py-4 bg-[#76eeda] hover:bg-[#5cdbc7] text-black font-bold text-sm tracking-wider uppercase rounded-none transition-all cursor-pointer"
              >
                {t('history.sec3_cta_form')}
              </button>
              <button
                onClick={() => navigate('/', { state: { scrollTo: 'vurdering-form' } })}
                className="px-8 py-4 border border-white hover:bg-white/10 text-white font-bold text-sm tracking-wider uppercase rounded-none transition-all cursor-pointer bg-transparent"
              >
                {t('history.sec3_cta_val')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
